import React from "react";
import logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className="w-full flex items-center justify-between bg-white px-10 py-3 bg-opacity-75 m-5">
      <a className="flex items-center cursor-pointer" href="#">
        <img src={require("../assets/logo.png")} alt="Logo" className="h-32" />
      </a>
      <nav className="ml-auto flex space-x-6 mr-10">
        <a href="#about-us" className="text-lg text-gray-800 hover:text-gray-600">
          About Us
        </a>
        <a href="#contact-us" className="text-lg text-gray-800 hover:text-gray-600">
          Contact Us
        </a>
      </nav>
    </header>
  );
};

export default Header;
